import React from 'react';
import OptionsAndOther from '../../choose_an_option';

export default function MentorConversationTopics({ answers, onSubmit, onBack, gtm }) {
  return (
    <div className={`row activity-question`}>
      <div className='col-sm-2'></div>
      <div className='col-sm-8'>
        <OptionsAndOther
          answers={{ mentorConversationTopics: answers.mentorConversationTopics }}
          onSubmit={(newAnswers) =>
            onSubmit({ ...answers, mentorConversationTopics: newAnswers.mentorConversationTopics })
          }
          onBack={onBack}
          title={`How are you looking for a mentor to help you? (Select all that apply)`}
          para={``}
          keyForAnswer={`mentorConversationTopics`}
          choices={[
            'Guidance on symptom management',
            'Coping with or managing side effects',
            `Personal insights into emotional impact and coping strategies`,
            `Advice on building and maintaining a support system`,
            `Specific questions about treatment`,
            `Tips on pharmacy support`,
          ]}
          showOther
          otherTxt={`Enter other topics here`}
          showBack
        />
      </div>
      <div className='col-sm-2'></div>
    </div>
  );
}
